import React, { useMemo } from 'react';
import { Stack, ThemeProvider, useTheme } from 'expo-router';

import { useTransparentModalStackOptions } from '../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function TransparentModalsLayout() {
  const options = useTransparentModalStackOptions();
  const theme = useTheme();

  // ─── Derived ─────────────────────────────────────────────────────────

  // NOTE: The native stack paints its container with the theme background,
  // which covers the screen below regardless of the stack's presentation.
  const stackTheme = useMemo(() => {
    return { ...theme, colors: { ...theme.colors, background: 'transparent' } };
  }, [theme]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <ThemeProvider value={stackTheme}>
      <Stack screenOptions={options.Stack}>
        <Stack.Screen name="apply-reward/[offerId]/index" />
        <Stack.Screen name="group-order-ended/[orderId]/index" />
      </Stack>
    </ThemeProvider>
  );
}
